module.exports = __webpack_public_path__ + "static/img/WhatFruitmapsDo.2887fd20.webp";